import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MaritalStatusEffects } from './marital-status.effects';
import { STORE_TYPE } from './marital-status.model';
import { maritalStatusReducer } from './marital-status.reducer';

@NgModule({
  imports: [StoreModule.forFeature(STORE_TYPE, maritalStatusReducer), EffectsModule.forFeature([MaritalStatusEffects])],
})
export class UIMaritalStatusStoreModule {}
